<template>
  <div class="reduced-kidney-function-instructions">
    <div class="section-image">
      <b-container>
        <b-row>
          <b-col>
            <h1 class="text-center section-name">NEDSATT NJURFUNKTION</h1>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <b-container class="view-container text-center break-word">
      <b-row v-if="user.isAdmin">
        <b-col sm="12">
          <mu-raised-button
            class="demo-raised-button"
            label="Ta bort"
            icon="remove"
            primary
            @click="openConfirmDialog"
          />
          <mu-raised-button
            class="demo-raised-button"
            :label="instruction.isPublished ? 'Avpublicera' : 'Publicera'"
            :icon="instruction.isPublished ? 'visibility_off' : 'visibility'"
            :backgroundColor="instruction.isPublished ? 'gray' : 'green'"
            primary
            @click="togglePublish"
          />
          <hr />
        </b-col>
      </b-row>
      <div class="name-info">
        <b-row>
          <b-col sm="12">
            <h1 :class="{'low-margin-bottom': user.isAdmin}">
              <editor
                :areaKey="'name'"
                v-model="instruction.name"
                :editable="user.isAdmin"
                :applyTextEditCallback="applyTextEdit"
                emptyLabel="[Läkemedelsnamn]"
              ></editor>
            </h1>
          </b-col>
        </b-row>
        <b-row v-if="user.isAdmin">
          <b-col sm="12">
            <small class="npl-title">NPL-id:</small>
            <p class="npl-id">
              <editor
                :areaKey="'nplId'"
                v-model="instruction.nplId"
                :editable="user.isAdmin"
                :applyTextEditCallback="applyTextEdit"
                emptyLabel="[NPL-id]"
              ></editor>
            </p>
          </b-col>
        </b-row>
      </div>
      <hr />
      <div class="quick-info">
        <b-row class="justify-content-md-center" v-if="instruction.substance || user.isAdmin">
          <b-col cols="3" class="text-right">
            <img
              v-b-tooltip.hover.auto
              title="Verksam substans"
              src="data:image/svg+xml;base64,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"
            />
          </b-col>
          <b-col cols="9" class="text-left substance break-word">
            <h5>
              <editor
                v-model="instruction.substance"
                :editable="user.isAdmin"
                :applyTextEditCallback="applyTextEdit"
                emptyLabel="[Substans]"
              ></editor>
            </h5>
          </b-col>
        </b-row>
        <hr />
      </div>
      <div class="detailed-info text-left">
        <div>
          <b-row v-if="generalInstructions.text || user.isAdmin">
            <b-col>
              <h4>Kunskapsstöd: Dosering vid nedsatt njurfunktion</h4>
              <a href="javascript:void(0)" v-b-toggle.collapse1 variant="primary">
                Generella anvisningar
                <i class="fa fa-angle-down"></i>
              </a>
              <b-collapse id="collapse1" class="mt-2">
                <div>
                  <editor
                    :areaKey="'gi'"
                    v-model="generalInstructions.text"
                    :editable="user.isAdmin"
                    :applyTextEditCallback="applyTextEditContent"
                    emptyLabel="[Generella anvisningar]"
                  ></editor>
                </div>
              </b-collapse>
            </b-col>
          </b-row>
        </div>
        <b-row v-if="instruction.fass || user.isAdmin">
          <b-col sm="12">
            <h4>FASS</h4>
          </b-col>
          <b-col sm="12">
            <editor
              :areaKey="'fa'"
              v-model="instruction.fass"
              :editable="user.isAdmin"
              :applyTextEditCallback="applyTextEdit"
              emptyLabel="[FASS]"
            ></editor>
          </b-col>
        </b-row>
        <b-row v-if="instruction.theRenalDrugHandbook || user.isAdmin">
          <b-col sm="12">
            <h4>The Renal drug handbook (RDH)</h4>
          </b-col>
          <b-col sm="12">
            <div>
              <editor
                :areaKey="'rh'"
                v-model="instruction.theRenalDrugHandbook"
                :editable="user.isAdmin"
                :applyTextEditCallback="applyTextEdit"
                emptyLabel="[The Renal drug handbook (RDH)]"
              ></editor>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="instruction.martindale || user.isAdmin">
          <b-col sm="12">
            <h4>Martindale</h4>
          </b-col>
          <b-col sm="12">
            <div>
              <editor
                :areaKey="'md'"
                v-model="instruction.martindale"
                :editable="user.isAdmin"
                :applyTextEditCallback="applyTextEdit"
                emptyLabel="[Martindale]"
              ></editor>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="instruction.drugdex || user.isAdmin">
          <b-col sm="12">
            <h4>Drugdex</h4>
          </b-col>
          <b-col sm="12">
            <div>
              <editor
                :areaKey="'dd'"
                v-model="instruction.drugdex"
                :editable="user.isAdmin"
                :applyTextEditCallback="applyTextEdit"
                emptyLabel="[Drugdex]"
              ></editor>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="instruction.theClinicalUseOfDrugs || user.isAdmin">
          <b-col sm="12">
            <h4>Applied Therapeutics - The Clinical Use Of Drugs</h4>
          </b-col>
          <b-col sm="12">
            <div>
              <editor
                :areaKey="'cu'"
                v-model="instruction.theClinicalUseOfDrugs"
                :editable="user.isAdmin"
                :applyTextEditCallback="applyTextEdit"
                emptyLabel="[Applied Therapeutics - The Clinical Use Of Drugs]"
              ></editor>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="instruction.theKidney || user.isAdmin">
          <b-col sm="12">
            <h4>Brenner & Rector´s The Kidney</h4>
          </b-col>
          <b-col sm="12">
            <div>
              <editor
                :areaKey="'tk'"
                v-model="instruction.theKidney"
                :editable="user.isAdmin"
                :applyTextEditCallback="applyTextEdit"
                emptyLabel="[Brenner & Rector´s The Kidney]"
              ></editor>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="instruction.geriatricDosageHandbook || user.isAdmin">
          <b-col sm="12">
            <h4>Geriatric Dosage Handbook</h4>
          </b-col>
          <b-col sm="12">
            <div>
              <editor
                :areaKey="'gd'"
                v-model="instruction.geriatricDosageHandbook"
                :editable="user.isAdmin"
                :applyTextEditCallback="applyTextEdit"
                emptyLabel="[Geriatric Dosage Handbook]"
              ></editor>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="instruction.other || user.isAdmin">
          <b-col sm="12">
            <h4>Övriga källor</h4>
          </b-col>
          <b-col sm="12">
            <div>
              <editor
                :areaKey="'os'"
                v-model="instruction.other"
                :editable="user.isAdmin"
                :applyTextEditCallback="applyTextEdit"
                emptyLabel="[Övriga källor]"
              ></editor>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
    <mu-dialog :open="confirmDialog" title="Bekräfta" @close="closeConfirmDialog">
      Är du säker på att du vill fortsätta?
      <mu-flat-button slot="actions" @click="deleteReducedKidneyFunctionDrug" primary label="Ja" />
      <mu-flat-button slot="actions" primary @click="closeConfirmDialog" label="Avbryt" />
    </mu-dialog>
  </div>
</template>

<script>
import {
  updateReducedKidneyFunctionDrug,
  deleteReducedKidneyFunctionDrug,
  updateContent
} from '../store/actions'

export default {
  name: 'ReducedKidneyFunction',
  data () {
    return {
      confirmDialog: false
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  props: ['id'],
  computed: {
    instruction () {
      let item = this.$store.getters.reducedKidneyFunctionDrugById(this.id)
      return item || {}
    },
    generalInstructions () {
      let item = this.$store.getters.contentByKey('ReducedKidneyFunction')
      if (!item) return ''
      return item || ''
    },
    user () {
      return this.$store.state.user
    }
  },
  methods: {
    applyTextEdit () {
      updateReducedKidneyFunctionDrug(this.$store, this.instruction)
    },
    applyTextEditContent () {
      updateContent(this.$store, this.generalInstructions)
    },
    deleteReducedKidneyFunctionDrug () {
      deleteReducedKidneyFunctionDrug(this.$store, this.instruction)
    },
    openConfirmDialog () {
      this.confirmDialog = true
    },
    closeConfirmDialog () {
      this.confirmDialog = false
    },
    togglePublish () {
      this.instruction.isPublished = !this.instruction.isPublished
      updateReducedKidneyFunctionDrug(this.$store, this.instruction)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h1,
h2 {
  font-weight: normal;
}

.name-info {
  padding: .5em 0;
  font-weight: bold;

  .npl-title {
    font-weight: bold;
  }

  .npl-id {
    margin-bottom: 0;
    padding: 0 0.5em;
    white-space: nowrap;
    color: $turkos;
  }

  h1 {
    margin-top: 0;
  }

  .low-margin-bottom {
    margin-bottom: 0.4em;
  }
}

.quick-info {
  img {
    width: 40px;
  }
  h5 {
    margin-bottom: 0;
  }
}

.detailed-info {
  .row {
    padding-top: 30px;
  }

  p {
    display: inline;
  }

  > img {
    margin-top: 4px;
  }
}

.item + .item:before {
  content: ", ";
}

.substance {
  margin-top: 8px;
}

.section-name {
  color: $white;
  margin: 0;
  font-weight: bold;
  font-size: 25pt;
  text-shadow: 0 0 10px #888;
}

.section-image {
  padding-top: 25px;
  top: 70px;
  z-index: -1;
  height: 95px;
  width: 100%;
  background-image: url("../assets/reduced-kidney-background.png");
  background-position-y: bottom;
  background-size: cover;
}

body .view-container {
  padding-top: 40px;
}
</style>
